import { render, staticRenderFns } from "./proof-view-approver.vue?vue&type=template&id=8c3b3ce2&scoped=true&"
import script from "./proof-view-approver.vue?vue&type=script&lang=js&"
export * from "./proof-view-approver.vue?vue&type=script&lang=js&"
import style0 from "./proof-view-approver.vue?vue&type=style&index=0&id=8c3b3ce2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c3b3ce2",
  null
  
)

export default component.exports